import { render, staticRenderFns } from "./RevenueDetailsView.vue?vue&type=template&id=74e41c74&scoped=true"
import script from "./RevenueDetailsView.vue?vue&type=script&lang=js"
export * from "./RevenueDetailsView.vue?vue&type=script&lang=js"
import style0 from "./RevenueDetailsView.vue?vue&type=style&index=0&id=74e41c74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74e41c74",
  null
  
)

export default component.exports